export const LOADING_STATIC_TEXT = [
  'Reviewing your request…',
  'Verifying account details…',
  'Preparing an update for you…',
  'Confirming the latest information…',
  'Finalizing changes…',
  'Completing your request…',
  'Retrieving necessary data…',
  'Ensuring everything is accurate…',
  'Processing…please hold briefly.',
  'One moment while we complete this action…',
] as const;
